

import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { UserDetails } from '../../../auth/authTypes';
import { useAppDispatch } from '../../../../app/hooks';
import { fetchTeamsById } from '../../../teams/teamsSlice';
import { ExclamationIcon } from '../../../../components/icons';

type ChannelProps = {
  userDetails: UserDetails | null;
}

const TeamMemberDetails: React.FC<ChannelProps> = React.memo(({ }) => {
  const [dataLoading, setDataLoading] = useState(false);
  const [boardsFetched, setBoardsFetched] = useState<any[]>([]);
  const dispatch = useAppDispatch();
  const { userId } = useParams<{ userId: any }>();
  const [TeamsFetched, setTeamsFetched] = useState<any | null>(null);
  const baseIdString = localStorage.getItem('UserBaseId') || localStorage.getItem('createBaseId');
  const baseId = baseIdString ? JSON.parse(baseIdString) : null;


  // fetch team by id

  useEffect(() => {
    const fetchTeams = async () => {
      setDataLoading(true); // Start loading
      try {
        const baseResponse = await dispatch(fetchTeamsById({ userId, id: baseId }));
        if (fetchTeamsById.fulfilled.match(baseResponse)) {
          setTeamsFetched(baseResponse.payload.data);
        } else {
          setTeamsFetched([]);
          console.error("Failed to fetch teams:", baseResponse.payload);
        }
      } catch (error) {
        console.error("Error fetching teams:", error);
        setTeamsFetched([]);
      } finally {
        setDataLoading(false); // Stop loading
      }
    };

    if (userId) {
      fetchTeams();
    }
  }, [userId, dispatch, baseId]);


  return (
    <>
  {/* <div className="flex flex-col gap-y-[4px] mt-[32px] mb-[24px]">
  <h2 className="text-[15px] font-medium leading-[22.8px] text-[#1c2024]">
    Team Details
  </h2>
  <p className="text-[13.3px] leading-[19px] text-[#5c5c5e] font-medium">
    Overview of the selected team's information.
  </p>
</div> */}


      <div className='w-full flex justify-center mt-[32px]'>

        {dataLoading ? (
          <div className="flex items-center justify-center relative z-50 py-10">
            <div className="simple-spinner-loader">
              <span></span>
            </div>
          </div>
        ) : !TeamsFetched || TeamsFetched.length === 0 ? (
          <div className='w-full mt-5 flex h-[100px] justify-center items-center flex-col gap-y-3'>
            <ExclamationIcon />
            <p className='text-[#0000007a] text-[13px]'>No results found</p>
          </div>
        ) : (
          <div className='w-full'>
            <div className='flex flex-col gap-y-[6px]'>
              <div className='flex items-center gap-x-2'>
                <span className='flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] border-none text-[0.625rem] font-medium text-white capitalize'
                  style={{ backgroundColor: TeamsFetched?.color || '#6b7280' }}>
                </span>
                {
                  TeamsFetched?.name &&
                  <h2 className="text-[15px] font-medium leading-[22.8px] text-[#1c2024]">{TeamsFetched?.name}</h2>
                }
             
              </div>
              {
                TeamsFetched?.description && 
                <p className="text-[13.3px] leading-[19px] text-[#5c5c5e] font-medium">
                {TeamsFetched?.description}
              </p>
              }
           
            </div>
          </div>
        )}
      </div>
    </>
  )
});

export default TeamMemberDetails